export const DATE_SEPARATOR_OPTIONS = [".", "-", "/"] as const
export type DateSeparatorOptionType = (typeof DATE_SEPARATOR_OPTIONS)[number]
export const DEFAULT_DATE_SEPARATOR: DateSeparatorOptionType = "."

export const DATE_ORDER_OPTIONS = ["DD.MM.YYYY", "MM.DD.YYYY", "YYYY.MM.DD"] as const
export type DateOrderOptionType = (typeof DATE_ORDER_OPTIONS)[number]
export const DEFAULT_DATE_ORDER: DateOrderOptionType = "DD.MM.YYYY"

const TIME_FORMAT_TOKEN = "HH:mm"
const DEFAULT_DATE_FNS_FORMAT_TOKEN = "dd.MM.yyyy"
const DATE_FNS_FORMAT_TOKEN_MAP: Record<DateOrderOptionType, string> = {
  "DD.MM.YYYY": "dd.MM.yyyy",
  "MM.DD.YYYY": "MM.dd.yyyy",
  "YYYY.MM.DD": "yyyy.MM.dd",
}

export const makeDateFnsFormatToken = (
  dateOrder: DateOrderOptionType,
  dateSeparator: DateSeparatorOptionType = DEFAULT_DATE_SEPARATOR,
  includeTime = false
): string => {
  const dateFormatString = DATE_FNS_FORMAT_TOKEN_MAP[dateOrder] || DEFAULT_DATE_FNS_FORMAT_TOKEN
  const formatToken = dateFormatString.replace(/\./g, dateSeparator)
  return includeTime ? `${formatToken} ${TIME_FORMAT_TOKEN}` : formatToken
}
